import * as yup from 'yup'
import { isValidCpf } from '../cpf'
import { todayOrFuture, isValidDate } from '../date/validation'

yup.setLocale({
  mixed: {
    default: 'Campo inválido',
    required: 'Campo obrigatório',
    notType: _ref => (_ref.type == 'date' ? 'Data inválida' : 'Valor inválido'),
  },
  array: {
    min: ({ min }) => (min == 1 ? 'Campo Obrigatório' : `Deve conter ao mínimo ${min} itens`),
  },
  string: {
    max: ({ max }) => `Deve ter no máximo ${max} caracteres`,
  },
  number: {
    min: ({ min }) => `Deve ser maior ou igual a ${min}`,
    max: ({ max }) => `Deve ser menor ou igual a ${max}`,
  },
})

yup.addMethod<yup.DateSchema>(yup.date, 'validRange', function (errorMessage?: string) {
  return this.test('valid-date', errorMessage || 'Data inválida', function (value) {
    return !value || isValidDate(value)
  })
})

yup.addMethod<yup.DateSchema>(yup.date, 'todayOrFuture', function (errorMessage?: string) {
  return this.test('todayOrFuture', errorMessage || 'Data não pode ser no passado', function (value) {
    return !value || todayOrFuture(value)
  })
})

yup.addMethod<yup.StringSchema>(yup.string, 'cpf', function (errorMessage?: string) {
  return this.test('valid-cpf', errorMessage || 'CPF inválido', function (value) {
    return !value || isValidCpf(value)
  })
})

export {}
